import React, { useContext, useState } from "react";
import "./styles.css";
import { StoreContext } from "../../../Library/contexts";
import { DEV_TYPE_VALUES, DEVICE_TYPES, SELLER_DES } from "../../../Library/constants";
import { ArrowRightIcon } from "../../../Assets/images/svgs";
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay } from "@chakra-ui/react";

const WalletCount = ({ label, count }) => (
  <div className={`dev-type-count unset-position`}>
    <p className="header-wallet-label">{label}: <span>{count || 0}</span></p>
  </div>
);

const HeaderWallet = () => {
  const { constants } = useContext(StoreContext);
  const DESIGNATION = JSON.parse(window.localStorage.getItem("des"));
  const [showModal, setShowModal] = useState(false);

  if (DESIGNATION !== SELLER_DES) return null;

  const walletCount = constants.wallet?.total || 0;
  const batWiseCount = constants.wallet?.batWiseCount || {};

  const generateData = () => {
    let data = [];

    DEVICE_TYPES.forEach(({ label }) => {
      if (batWiseCount[DEV_TYPE_VALUES[label]]) {
        data.push({
          label,
          count: batWiseCount[DEV_TYPE_VALUES[label]],
        });
      }
    });

    data.sort((a, b) => b.count - a.count);

    data.forEach((item, idx) => {
      item.isNotLastItem = idx !== data.length - 1;
    });

    return data;
  };

  return (
    <div className="header-wallet">
      <div className="wallet-total">
        <p className="header-wallet-label">Devices In Stock: <span>{walletCount}</span></p>
      </div>
      {generateData().slice(0,2).map((item, idx) => {
        return (
          <React.Fragment key={idx}>
            <WalletCount label={item.label.length && item.label.replace("Battery","")} count={item.count} />
            {item.isNotLastItem && ( <div className="dev-type-seperator"></div> )}
          </React.Fragment>
        );
      })}

      {(generateData().length > 2) && (
        <div className="view-all">
          <span onClick={() => setShowModal(true)}>
            View all <ArrowRightIcon />
          </span>
        </div>
      )}

    <Modal isOpen={showModal} onClose={() => setShowModal(false)} isCentered size={"xl"}>
      <ModalOverlay />
      <ModalContent className="header-wallet-modal-content">
        <ModalCloseButton />
        <ModalBody className="header-wallet-modal-body">
          <div className="wallet-total modal">
            <p className="header-wallet-label">Devices In Stock: <span>{walletCount}</span></p>
          </div>
          <div className="header-wallet-devices-cnt">
            {generateData().map((item, idx) => {
              return (
                <React.Fragment key={idx}>
                  <WalletCount label={item.label} count={item.count} />
                </React.Fragment>
              );
            })}
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
    </div>
  );
};

export default HeaderWallet;
